import { DateTime } from "luxon";
import { LEGACY_TIME_ZONE } from "@/shared/utils/LegacyDates.ts";

export type ScheduleRange = "DAY" | "WEEK" | "MONTH";

export const allScheduleRanges: ScheduleRange[] = ["DAY", "WEEK", "MONTH"];

export function computeEndDateForRange(
  startDate: Date,
  range: ScheduleRange,
): Date {
  switch (range) {
    case "DAY": {
      return startDate;
    }
    case "MONTH": {
      return DateTime.fromJSDate(startDate, { zone: LEGACY_TIME_ZONE })
        .plus({ month: 1 })
        .minus({ day: 1 })
        .toJSDate();
    }
    case "WEEK": {
      return DateTime.fromJSDate(startDate, { zone: LEGACY_TIME_ZONE })
        .plus({ day: 6 })
        .toJSDate();
    }
  }
}
